import ToyHttp2 from '@toy/http2';
import { API_BASE, SYSTEM_ENUM } from '@/core/http/env';
import { CURRENT_CLIENT_CODE } from '@/constant';
import { useInstances } from '@/hooks/use-instances';

const { getVueRouterInstance } = useInstances();

const http = new ToyHttp2<SYSTEM_ENUM>({
  requestDefaultConfig: {
    server: SYSTEM_ENUM.NEST_API,
  },
});

http.setDomain(API_BASE);
http.setHeader({
  'Client-Code': CURRENT_CLIENT_CODE,
});

http.setForbiddenCallback(async () => {
  // 跳转403
  getVueRouterInstance().push('/403');
});

export default http;
